import { Component } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'safe-connect-security-info',
	template: require('./safe-connect-security-info.component.html'),
	host: { class: 'flex-column ' },
})
export class SafeConnectSecurityInfoComponent {
	public isRebrading = AppSettings.isRebrading;
}
